import React from 'react';
import { Select } from 'antd';
import { toast } from 'react-toastify';
import { postApi } from '../../../Services/apiService';

const { Option } = Select;

const ConvertOutModal = ({
  modalConvertOut,
  setModalConvertOut,
  modalRef,
  rawProductOptions,
  selectedRawProductForModal,
  setSelectedRawProductForModal,
  setSelectedManualConvertOutPrepackProduct,
  setSelectedManualConvertOutQuantity,
  prepackProductsForDropdown,
  selectedManualConvertOutPrepackProduct,
  selectedManualConvertOutDate,
  selectedManualConvertOutQuantity,
  isFetchingQuantity,
  setIsFetchingQuantity,
  setSelectedManualConvertOutRawProductId,
  setSelectedManualConvertOutFinishedProductId,
  setSelectedManualConvertOutDate,
  setRawProductOptions,
  debouncedUpdateConvertOutData
}) => {
  if (!modalConvertOut) return null;

  const handleClose = () => {
    setModalConvertOut(false);
    setSelectedManualConvertOutPrepackProduct(null);
    setSelectedManualConvertOutQuantity(null);
    setSelectedManualConvertOutRawProductId(null);
    setSelectedManualConvertOutFinishedProductId(null);
    setSelectedManualConvertOutDate(null);
    setSelectedRawProductForModal(null);
    setRawProductOptions([]);
  };

  const handleFinishedProductChange = async (newValue) => {
    setSelectedManualConvertOutPrepackProduct(newValue || null);
    if (newValue) {
      setIsFetchingQuantity(true);
      try {
        const resp = await postApi('/prepack-manual-convert-out/get-quantity', {
          raw_product_id: selectedRawProductForModal,
          finished_product_id: newValue,
          date: selectedManualConvertOutDate
        });
        if (resp?.success && resp?.data?.quantity !== null) {
          setSelectedManualConvertOutQuantity(resp.data.quantity);
        } else {
          setSelectedManualConvertOutQuantity('');
        }
      } catch (error) {
        console.error('Error fetching quantity:', error);
      } finally {
        setIsFetchingQuantity(false);
      }
    }
  };

  const handleAdd = () => {
    if (!selectedRawProductForModal || !selectedManualConvertOutPrepackProduct || !selectedManualConvertOutQuantity) {
      toast.error('Please select all fields');
      return;
    }
    handleClose();
    debouncedUpdateConvertOutData({
      raw_product_id: selectedRawProductForModal,
      finished_product_id: selectedManualConvertOutPrepackProduct,
      date: selectedManualConvertOutDate,
      quantity: selectedManualConvertOutQuantity
    }, `sales-${selectedManualConvertOutPrepackProduct}`);
  };

  return (
    <div className="modal-overlay custom-overlay product-quantity-add" ref={modalRef} role="dialog" aria-modal="true">
      <div className="modal-content custom-modal add-custom-stock multiple-reserve convert-out">
        <div className='position-relative'>
          <div className="modal-header">
            <h3>Convert Out</h3>
            <img
              style={{ top: '0', right: '0' }}
              src={window.getPublicUrl('/assets/images/close.svg')}
              onClick={handleClose}
              className="close"
              alt="Close"
            />
          </div>
          <div className="col-sm-12">
            <div className="form-group select-drop-down">
              <label htmlFor="rawProduct" className="d-block">
                Select Raw Product
              </label>
              <div className="multi-select-container" style={{ width: '100%', maxWidth: '400px' }}>
                <Select
                  showSearch
                  allowClear
                  value={selectedRawProductForModal || undefined}
                  onChange={(newValue) => {
                    setSelectedRawProductForModal(newValue ?? null);
                    setSelectedManualConvertOutPrepackProduct(null); // Reset finished product selection
                    setSelectedManualConvertOutQuantity(''); // Reset quantity
                  }}
                  placeholder="Select raw product..."
                  optionLabelProp="children"
                  optionFilterProp="children"
                  className="custom-multiselect"
                  dropdownClassName="prepack-product-dropdown"
                  getPopupContainer={trigger => trigger.parentNode}
                >
                  {Array.isArray(rawProductOptions) &&
                    rawProductOptions
                      .filter((item) => item?.id != null)
                      .map((item) => (
                        <Option key={item.id} value={item.id}>
                          {`${item.code} | ${item.name}`}
                        </Option>
                      ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group select-drop-down">
              <label htmlFor="finishedProduct" className="d-block">
                Select Finished Product
              </label>
              <div className="multi-select-container" style={{ width: '100%', maxWidth: '400px' }}>
                <Select
                  showSearch
                  allowClear
                  value={selectedManualConvertOutPrepackProduct || undefined}
                  onChange={handleFinishedProductChange}
                  placeholder="Select finished product..."
                  optionLabelProp="children"
                  optionFilterProp="children"
                  className="custom-multiselect"
                  dropdownClassName="prepack-product-dropdown"
                  getPopupContainer={trigger => trigger.parentNode}
                  disabled={!selectedRawProductForModal}
                >
                  {Array.isArray(prepackProductsForDropdown) &&
                    prepackProductsForDropdown.map((item) => (
                      <Option key={item?.id} value={item?.finished_product_id}>
                        {`${item?.finished_product_code} | ${item?.finished_product_name_tc}`}
                      </Option>
                    ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group select-drop-down">
              <label htmlFor="customerSubGroup" className="d-block">
                Quantity
              </label>

              <input
                type="text"
                className="inout-tab mt-0"
                value={selectedManualConvertOutQuantity}
                onChange={(e) => {
                  setSelectedManualConvertOutQuantity(e.target.value);
                }}
                disabled={!selectedManualConvertOutPrepackProduct || isFetchingQuantity}
              />
            </div>
          </div>

          <div className="col-sm-12 text-right mt-3">
            <button
              className="btn btn-primary"
              onClick={handleAdd}
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvertOutModal;
